import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './CustomerOrderUploadFile.css';

const CUSTOMER_ORDER_ROOT =
  process.env.REACT_APP_CUSTOMER_ORDER_START_PATH || '/customer-order';

function CustomerOrderUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={CUSTOMER_ORDER_ROOT}
      sessionPrefix="customer_order_file"
    />
  );
}

CustomerOrderUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default CustomerOrderUploadFile;
